import React from "react"

export default function PartnerShowcaseComponent({ image, name, title, phone, email, windowWidth }) {
  const imageClass = image !== null ? `` : `no-image`
  const trimmedPhone = phone.replaceAll(" ", "")
  return (
    <div className="partner-showcase-item">
      <div className={`partner-showcase-item-image-wrapper ` + imageClass}>
        <img data-epi-property="ProfileImage" src={image} />
      </div>
      <p data-epi-property="PartnerName" className="partner-showcase-item-name">
        {name}
      </p>
      <p data-epi-property="PartnerTitle" className="partner-showcase-item-title">
        {title}
      </p>
      {windowWidth <= 768 ? (
        <a data-epi-property="PartnerPhone" href={`tel:${trimmedPhone}`} className="partner-showcase-item-phone contact-link">
          {phone}
        </a>
      ) : (
        <p data-epi-property="PartnerPhone" className="partner-showcase-item-phone">
          {phone}
        </p>
      )}
      <a data-epi-property="PartnerEmail" href={`mailto:${email}`} className="partner-showcase-item-email contact-link">
        {email}
      </a>
    </div>
  )
}
